import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useApplicationContext } from '../../utils/applicationContext';
import { TRecommendation } from '../../types/recommendation';
import { selectPhoneAuthBlockerExperimentEnabled } from '../../selectors/experiments';

export function useGetIsAuthenticationPopupEnabled(offer: TRecommendation | null): boolean {
  const { config } = useApplicationContext();

  const isExperimentEnabled = useSelector(selectPhoneAuthBlockerExperimentEnabled);

  const isHidingPhoneNumberEnabled = config.get<boolean>('BX.HidingPhoneNumber.Enabled') ?? false;
  const hidingPhoneNumberRegions = config.get<number[]>('BX.HidingPhoneNumber.Regions') ?? [];

  return useMemo(() => {
    if (!offer) {
      return false;
    }
    const { offerType, category, geo, author } = offer;

    const regionId = geo?.regionId && hidingPhoneNumberRegions.includes(geo.regionId);

    return (
      isHidingPhoneNumberEnabled &&
      isExperimentEnabled &&
      Boolean(regionId) &&
      !author?.isPro &&
      !author?.fromDeveloper &&
      offerType === 'flat' &&
      (category === 'flatSale' || category === 'flatRent' || category === 'dailyFlatRent')
    );
  }, [isHidingPhoneNumberEnabled, isExperimentEnabled, offer]);
}
